<template>
	<div class="index-content__div">
		<div ref="index_search" class="index_search">
			<div class="index_header">
				<img
					:class="location ? 'header_logo' : 'header_logo_province'"
					:src="location ? '../static/img/header_logo.png' : '../static/img/logo_new1.png'" />
				<div v-if="!location" class="header_box"></div>
				<span class="header_title" :style="!location ? 'color:#3A79C0' : ''">{{ location ? location + '宣传文化云数据大脑' : '数据大脑' }}</span>
				<span class="header_loc"></span> -->
			</div>
			<el-carousel>
				<el-carousel-item v-for="item in 4" :key="item">
				</el-carousel-item>
			</el-carousel>
			<div class="select-search-wrapper">
				<img src="../static/img/boder.png" class="index-inputArea__boder" />
				<div class="index-inputArea__div">
					<div class="index_icon">
						<ul class="index-searchType__ul">
							<li class="index-ul__li"
									@click="changeSearchType('contentSearch')">
								<img src="../static/img/0h-icon.png"
										alt=""
										v-if="searchType == 'contentSearch'">
								<img src="../static/img/0-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'contentSearch' }">内容搜索</span>
							</li>
							<li class="index-ul__li"
									@click="changeSearchType('pressMedia')">
								<img src="../static/img/1h-icon.png"
										alt=""
										v-if="searchType == 'pressMedia'">
								<img src="../static/img/1-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'pressMedia' }">发稿媒体</span>
							</li>
							<li class="index-ul__li"
									@click="changeSearchType('editorReporter')">
								<img src="../static/img/2h-icon.png"
										alt=""
										v-if="searchType == 'editorReporter'">
								<img src="../static/img/2-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'editorReporter' }">编辑记者</span>
							</li>
							<li class="index-ul__li"
									@click="changeSearchType('contentName')">
								<img src="../static/img/3h-icon.png"
										alt=""
										v-if="searchType == 'contentName'">
								<img src="../static/img/3-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'contentName' }">内容人名</span>
							</li>
							<li class="index-ul__li"
									@click="changeSearchType('contentDepartment')">
								<img src="../static/img/4h-icon.png"
										alt=""
										v-if="searchType == 'contentDepartment'">
								<img src="../static/img/4-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'contentDepartment' }">内容机构</span>
							</li>
							<li class="index-ul__li"
									@click="changeSearchType('contentSites')">
								<img src="../static/img/5h-icon.png"
										alt=""
										v-if="searchType == 'contentSites'">
								<img src="../static/img/5-icon.png"
										alt=""
										v-else>
								<span :class="{ active: searchType == 'contentSites' }">内容地点</span>
							</li>
						</ul>
					</div>
					<div class="index-search__input">
						<div class="triangle_border_up"
								v-if="searchType == 'contentSearch'"><span></span></div>
						<div class="triangle_border_up choose-1"
								v-if="searchType == 'pressMedia'"><span></span></div>
						<div class="triangle_border_up choose-2"
								v-if="searchType == 'editorReporter'"><span></span></div>
						<div class="triangle_border_up choose-3"
								v-if="searchType == 'contentName'"><span></span></div>
						<div class="triangle_border_up choose-4"
								v-if="searchType == 'contentDepartment'"><span></span></div>
						<div class="triangle_border_up choose-5"
								v-if="searchType == 'contentSites'"><span></span></div>
						<div class="index_input_box">
							<input type="text"
										v-model="searchKeyWorld"
										placeholder="请输入关键词"
										@keyup.enter='searchContent()'>
							<img src="../static/img/searchicon.png"
									alt=""
									@click.stop='searchContent()'>
						</div>
					</div>
					<img class="bottom_border" src="../static/img/bottom_border.png" />
				</div>
			</div>
			<div class="index_total">
				<div class="index_total_inner">
					<div class="index_total_item">
						<span>{{total.contentTotal}}</span>
						<img src="../static/img/jiantou_line.png" />
						<span>稿件总数</span>
					</div>
					<div class="index_total_item">
						<span>{{total.mediaTotal}}</span>
						<img src="../static/img/jiantou_line.png" />
						<span>媒体总数</span>
					</div>
					<div class="index_total_item">
						<span>{{total.reporterTotal}}</span>
						<img src="../static/img/jiantou_line.png" />
						<span>记者总数</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="location" class="index_searchbox">
			<div class="index_select">
				<el-radio-group v-model="tabPosition" stretch class="index_select_group">
					<el-radio-button label="县区">
						<img src="../static/img/diyu@2x.png" alt="" v-if='tabPosition == "县区"'>
						<img src="../static/img/diyuyi@2x.png" v-else/>县区</el-radio-button>
					<el-radio-button label="媒体单位">
						<img src="../static/img/meitiyi@2x.png" alt="" v-if='tabPosition == "媒体单位"'>
						<img src="../static/img/meiti@2x.png"   v-else/>媒体单位</el-radio-button>
					<!-- <el-radio-button label="行业主题">
						<img src="../static/img/zhutiyi@2x.png" alt="" v-if='tabPosition == "行业主题"'>
						<img src="../static/img/zhuti@2x.png"  v-else/>行业主题</el-radio-button> -->
				</el-radio-group>
				<div class="index_select_wrapper">
					<div class="index_select_list" ref="index_select_list" v-show='tabPosition == "县区"'>
						<div class="index_select_item" 
							@mouseenter="changeColor(item)"
							@mouseleave="backColor(item)" 
							@click="getResult(item)" :id="item" v-for="(item,index) in showList" :key="index">
							<img src="../static/img/ditu@2x.png" />
							<span>{{item}}</span>
						</div>
					</div>

					<div class="media_select_list" ref="media_select_list" v-show='tabPosition == "媒体单位"'>
						<div class="index_select_muni">
							<img src="../static/img/shijimeiti.png" />
							<span class="index_select_title">市级媒体</span>
						</div>
						<div class="index_select_toggle">
							<div @click="getResult(item)"
								@mouseenter="changeColor(item)"
								@mouseleave="backColor(item)"
							 	class="index_select_media" :id="item.mc" v-for="(item,index) in cMediaList" :key="index">
								<span v-if="item.mc" class="select_media_title">{{item.mc}}</span>
								<span v-if="item.tj && item.tj.wzzs" class="select_media_num">{{item.tj.wzzs}}条数据</span>
							</div>
						</div>
						<div class="index_select_county">
							<img src="../static/img/xianjimeiti.png" />
							<span class="index_select_title">县级媒体</span>
						</div>
						<div class="index_select_toggle">
							<div @click="getResult(item)"
								@mouseenter="changeColor(item)"
								@mouseleave="backColor(item)"
								class="index_select_media" :id="item.mc" v-for="(item,index) in lMediaList" :key="index">
								<span v-if="item.mc" class="select_media_title">{{item.mc}}</span>
								<span v-if="item.tj && item.tj.wzzs" class="select_media_num">{{item.tj.wzzs}}条数据</span>
							</div>
						</div>
					</div>

					<!-- <div class="theme_select_list" ref="theme_select_list" v-show='tabPosition == "行业主题"'>
						<div class="theme_item" 
							@mouseenter="changeColor(item)"
							@mouseleave="backColor(item)" 
							@click="getResult(item)" :id="item.name" v-for="(item,index) in themeList" :key="index">
							<span>{{item.name}}</span>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div v-if="location" class="index_type_top">			
			<span class="index_title">
				数据分类
			</span>
		</div>
		<div v-if="location" class="index_search_type">
			<div class="index_type">
				<div class="index_type_bottom">
					<div class="index_type_item1" @click="toTv">
						<div class="type_img_wrapper">
							<img src="../static/img/dianshitai.png" alt="">
						</div>
						<span>电视台</span>
					</div>
					<div class="index_type_item2" @click="toWechat">
						<div class="type_img_wrapper">
							<img src="../static/img/weixin.png" alt="">
						</div>
						<span>微信</span>
					</div>
					<div class="index_type_item3" @click="toApp">
						<div class="type_img_wrapper">
							<img src="../static/img/app.png" alt="">
						</div>
						<span>抖音</span>
					</div>
					<div class="index_type_item4" @click="toweibo">
						<div class="type_img_wrapper">
							<img src="../static/img/weibo.png" alt="">
						</div>
						<span>网站</span>
					</div>
					<div class="index_type_item5" @click="tozhimei">
						<div class="type_img_wrapper">
							<img src="../static/img/zhimei.png" alt="">
						</div>
						<span>数字报</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="location" class="index_footer">
			<div class="index_footer_link">
				<div class="index_link_wrapper">
					<span class="index_link_item">友情链接</span>
					<span class="index_link_line">&Iota;</span>
					<span class="index_link_item">友情链接</span>
					<span class="index_link_line">&Iota;</span>
					<span class="index_link_item">友情链接</span>
					<span class="index_link_line">&Iota;</span>
					<span class="index_link_item">友情链接</span>
					<span class="index_link_line">&Iota;</span>
					<span class="index_link_item">友情链接</span>
				</div>
			</div>
			<div class="index_footer_copy">
				<div class="index_copy_wrapper">
					<div class="index_copy_item">
						<span>&copy;&nbsp;2019&nbsp;&nbsp;&nbsp;&nbsp;京ICP备16053197号-2</span>
					</div>
					<div class="index_copy_item">
						<span>京公安网备11010802025696号</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {_get} from '../api/index.js';
export default {
	name: 'index',
	data() {
		return {
			searchKeyWorld: '',
			searchType: 'contentSearch',
			total:{},
			tabPosition:'县区',
			location:'',
			locList:[],
			mediaList:[],
			cMediaList:[],
			lMediaList:[],
			themeList:[],
			showList:[],
			address:['贵州省'],
			addressPath:''
		}
	},
	mounted(){
		this.getlocation()
		this.$nextTick(()=>{
			this.getStatistics()
		})
	},
	methods: {
		getlocation () {
			let storage = window.localStorage
			if (this.$route.query.address) {
				storage.setItem('address', this.$route.query.address)
				this.addressPath = this.$route.query.address
				let address = this.$route.query.address.split('-')
				if (Array.isArray(address) && address.length > 1) {
					this.location = address[1]
				} else {
					this.$refs.index_search.style.height = '100%'
				}
			} else {
				this.location = ''
				storage.setItem('address', '贵州省')
				this.$refs.index_search.style.height = '100%'
			}
		},
		getStatistics(){
			let url = ''
			if (this.location) {
				url = 'homes/statistical?sheng=贵州省&shi=' + this.location
			} else {
				url = 'homes/statistical?sheng=贵州省'
			}
			// var locUrl = 'address/0'
			_get(url).then((res)=>{
				this.total = res.data.data
				//console.log(this.total)
			}).catch((res)=>{
				console.log(res)
			})
			// _get(locUrl).then((res)=>{
			// 	console.log(res)
			// 	this.location = res.data.data[0].name
			// }).catch((res)=>{
			// 	console.log(res)
			// })
		},
		getAllList(){
			let urlAll = 'homes/address?sheng=贵州省&shi=' + this.location
			let urlMedia = 'homes/medias?sheng=贵州省&shi=' + this.location
			let urlTheme = 'themes/1'
			this.$axios.all([
				_get(urlAll),
				_get(urlMedia),
				_get(urlTheme)
			]).then(res => {
				this.locList = res[0].data.data
				this.mediaList = res[1].data.data
				//console.log(this.mediaList)
				for(var i = 0;  i < this.mediaList.length; i++){
					if(this.mediaList[i].mtjb){
						if(this.mediaList[i].mtjb.indexOf("市级") > -1){
							this.cMediaList.push(this.mediaList[i])
						}else if(this.mediaList[i].mtjb.indexOf("县级") > -1){
							this.lMediaList.push(this.mediaList[i])
						}
					}
				}
				this.themeList =res[2].data.data
				//console.log(this.themeList)
				if(this.tabPosition == '县区'){
					this.showList = this.locList
				}
			}).catch((res)=>{
				console.log(res)
			});
		},
		changeColor(item){
			if(this.tabPosition.indexOf('县区') > -1){
				let ele = document.getElementById(item)
				ele.childNodes[0].src = '../static/img/dituyi@2x.png'
				ele.style.color = '#FF8752'
			}
			else if(this.tabPosition.indexOf('媒体单位') > -1){
				let media =  document.getElementById(item.mc)
				media.style.color = '#FF8752'
				media.style.backgroundImage = "url('../static/img/fourBorder1.png')";
			}
			else if(this.tabPosition.indexOf('行业主题') > -1){
				let theme = document.getElementById(item.name)
				theme.style.backgroundImage = "url('../static/img/eightBorder1.png')";
				theme.style.color =  '#fff'
			}
		},
		backColor(item){
			if(this.tabPosition.indexOf('县区') > -1){
				let ele = document.getElementById(item)
				ele.childNodes[0].src = '../static/img/ditu@2x.png' 
				ele.style.color = '#999999'
			}
			else if(this.tabPosition.indexOf('媒体单位') > -1){
				let media =  document.getElementById(item.mc)
				media.style.color = '#999999'
				media.style.backgroundImage = "url('../static/img/fourBorder.png')";
			}
			else if(this.tabPosition.indexOf('行业主题') > -1){
				let theme = document.getElementById(item.name)
				theme.style.backgroundImage = "url('../static/img/eightBorder.png')";
				theme.style.color =  '#FF8752'
			}
		},
		changeSearchType(num) {
			this.searchType = num
		},
		toTv(){
			this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,source_type:"电视台",address:this.addressPath}
				})
		},
		toWechat(){
			this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,source_type:"微信公号",address:this.addressPath}
				})
		},
		toApp(){
			this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,source_type:"抖音",address:this.addressPath}
				})
		},
		toweibo(){
			this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,source_type:"网站",address:this.addressPath}
				})
		},
		tozhimei(){
			this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,source_type:"数字报",address:this.addressPath}
				})
		},
		getResult(item){
			if(this.tabPosition == '县区'){
				this.address.push(this.location)
				this.address.push(item)
				//console.log(this.address)
				var path = this.address.join('-')
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{sort:'desc',from:0,size:10,address:path}
				})
				//console.log(path)
			}else if(this.tabPosition == '媒体单位'){
				this.$router.push({
					//你需要接受路由的参数再跳转
					path: "/pressMedia/pressmediadetail",
					query:{id:item.id}
      			});
			}else if(this.tabPosition == '行业主题'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{index:item.name,sort:'desc',from:0,size:10,address:this.addressPath}
				})
			}
		},
		searchContent() {
			//console.log(this.searchKeyWorld)
			if (this.searchType == 'contentSearch') {
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentsearch',
					query:{index:this.searchKeyWorld,sort:'desc',from:0,size:10,address:this.addressPath}
				})
			}
			if(this.searchType == 'pressMedia'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/pressMedia',
					query:{index:this.searchKeyWorld,from:0,size:10,address:this.addressPath}
				})
			}
			if(this.searchType == 'editorReporter'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/editorReporter',
					query:{index:this.searchKeyWorld,from:0,size:10,address:this.addressPath}
				})
			}
			if(this.searchType == 'contentName'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentName',
					query:{index:this.searchKeyWorld,type:'person',sort:'desc',from:0,size:10,address:this.addressPath}
				})
			}
			if(this.searchType == 'contentDepartment'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentDepartment',
					query:{index:this.searchKeyWorld,type:'organization',sort:'desc',from:0,size:10,address:this.addressPath}
				})
			}
			if(this.searchType == 'contentSites'){
				this.$router.push({//你需要接受路由的参数再跳转
					path: '/contentSites',
					query:{index:this.searchKeyWorld,type:'address',sort:'desc',from:0,size:10,address:this.addressPath}
				})
			}
		}
	},
	watch:{
		tabPosition:function (val) {
			if(val == '县区'){
				this.showList = this.locList
			}else if(val == '媒体单位'){
				this.showList = this.mediaList
			}else if(val == '行业主题'){
				this.showList = this.themeList
			}
		},
		location(val){
			this.getAllList()
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.triangle_border_up {
  width: 0;
  height: 0;
  border-width: 0px 12px 15px;
  border-style: solid;
  border-color: transparent transparent #fff;
  position: relative;
  left: 42px;
}
.choose-1 {
  left: 147px;
}
.choose-2 {
  left: 251px;
}
.choose-3 {
  left: 353px;
}
.choose-4 {
  left: 457px;
}
.choose-5 {
  left: 561px;
}

.active {
  color: #26E8FF !important;
}
.index-search__input {
    width: 89%;
	margin: 5px auto 23px 30px;
}
.index-inputArea__div .index_icon{
	width: 624px;
	height: 85px;
	display: flex;
	margin-top: 30px;
	justify-content: space-between;
}
.index-content__div .bottom_border {
	width: 608px;
  height: 5px;
  margin: 0 auto;
}
.index-search__input input {
  width: 100%;
  padding: 10px 0;
}
.index-title__p {
  font-size: 50px;
  font-family: "微软雅黑";
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin: 0;
}
.index-content__div {
  display: flex;
  width: 100%;
	height: 100%;
  flex-direction: column;
}
.index_header{
	height: 90px;
	position: absolute;
	left: 25px;
	top: 20px;
	display: flex;
	align-items: center;
	z-index: 6;
}
.index_header .header_logo{
	margin: 10px 15px 10px 20px;
}
.index_header .header_logo_province{
	height: 60px;
	margin: 10px 0 10px 20px;
}
.index_header .header_title{
	display: flex;
	align-items: center;
	font-size: 32px;
	height: 38px;
	font-family:	思源黑体;
	font-weight:bold;
	color:rgba(255,255,255,1);
	line-height:16px;
	content: attr(text);
	margin-right: 15px;
}
.index_header .header_box{
	width:41px;
	height:4px;
	margin-right: 15px;
	margin-left: 20px;
	background:linear-gradient(90deg,rgb(58, 121, 192),rgb(58, 121, 192));
}
.index_header .header_loc{
	font-size:26px;
	font-family:思源黑体;
	font-weight:bold;
	color:rgba(255,135,82,1);
	line-height:16px;
	margin-right: 15px;
}
.index_search{
	height: 821px;
	position: relative;
	background-size: 100% 100%
}
.index_search_copy{
	width: 100%;
	height: 100%;
	position: relative;
	background-size: 100% 100%
}
.index-inputArea__boder{
	width: 5px;
	height: 276px;
	margin-right: 9px;
}
.index-inputArea__div {
	width: 691px;
	height: 270px;
	border: 3px solid #fff;
	border-radius:20px 0px 20px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.index-ul__li {
  float: left;
	width: 64px;
	height: 64px;
	display: flex;
	flex-direction: column;
	align-items: center;
  cursor: pointer;
  margin: 0 20px;
  text-align: center;
}
.index-ul__li img {
  margin-bottom: 6px;
	width: 35px;
	height: 35px;
}
.index-ul__li span {
	width: 100%;
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: 400;
  color: #fff;
}
.index-searchType__ul {
	width: 100%;
	height: 100%;
  padding: 0;
  margin: 0;
  margin-top: 17px;
  margin-bottom: 5px;
  list-style: none;
  display: flex;
  justify-content: space-around;
}
.index_input_box {
  height: 42px;
	width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  padding-left: 18px;
  display: flex;
}
.index_input_box input {
  padding-top: 10px;
  color: #666666;
  font-size: 14px;
  border: none;
  outline: none;
}
.index_input_box img {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 11px;
  margin-left: 7px;
	margin-right: 10px;
}
.index_total{
	height: 128px;
	width: 980px;
	position: absolute;
	left:0px;
	right: 0px;
	bottom: 182px;
	margin:auto;
	z-index: 6;
}
.index_total_inner{
	display: flex;
	justify-content: space-around;
	height: 100%;
	margin: 0 auto;
}
.index_total_item{
	width: 188px;
	height: 128px;
	align-items: center;
	background-image: url('../static/img/total_bg.png');
  background-size: 100% 100%;
	z-index: 6;
	display: flex;
	margin: auto 0px;
	flex-direction: column;
	align-self: center;
}
.index_total_item span:first-child{
	font-size:24px;
	font-family:	思源黑体;
	font-weight:bold;
	color:#fff;
	line-height:16px;
	margin-top:36px;
	margin-bottom: 14px;
}
.index_total_item span{
	margin-top: 14px;
	font-size:16px;
	font-family:	思源黑体;	
	font-weight:bold;
	color:#D0E8FF ;
	line-height:16px;
}
.index_total_item img {
	width: 160px;
}
.index_select{
	height: 400px;
	width: 1200px;
	margin: 0 auto;
	margin-top: -47px;
	border-radius: 6px;
	font-family:思源黑体;
}
.index_search_type{
	width:100%;
	height: 620px;
	background:#266CE4;
}
.index_type{
	width: 1200px;
	margin: 0 auto;
	margin-top: 20px;
	display: flex;
	flex-direction: column;	
}
.index_type_top{
	width: 861px;
	height: 59px;
    display: flex;
    margin: 20px auto 36px;
	background-image: url('../static/img/type.png');
	background-size: 100% 100%;
}
.index_advantage{
	display: flex;
	flex-direction: column;
	height: 400px;
	width: 1200px;
	margin: 0 auto;
	margin-top: 20px;
	margin-bottom: 50px;
}
.index_advantage_inner{
	display: flex;
	justify-content: space-between;
}
.index_advantage_item{
	margin-top: 20px;
	width: 256px;
	height: 340px;
	display: flex;
	flex-direction: column;
}
.image-bg{
	width: 256px;
	height: 264px;
	background-image: url('../static/img/advantage_bg.png');
	background-size: 100% 100%;
	display: flex;
	align-items: center;
}
.index_advantage_item img {
	margin: auto 0;
	width: 187px;
	height: 185px;
	border-radius: 4px;
}
.index_advantage_item span {
	margin-top: 15px;
	margin-left: 10px;
	font-size:16px;
	font-family:思源黑体;
	font-weight:bold;
	color:rgba(102,102,102,1);
	line-height:20px;
	letter-spacing: 1px;
	word-wrap:break-word ;
}
.index_title{
	width: 105px;
	height: 50px;
	font-size:24px;
	font-family:思源黑体;
	font-weight:bold;
	color:rgba(255,255,255,1);
	margin: 8px auto 0px auto;
}
.index_search .el-carousel {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	position: relative;
}
.index_search .el-carousel__item:nth-child(2n) {
	background-image: url("../static/img/header_bg.png");
	background-size: 100% 100%
}

.index_search .el-carousel__item:nth-child(2n+1) {
	background-image: url("../static/img/header_bg.png");
	background-size: 100% 100%
}
.index_search .el-carousel .el-carousel__container {
	height: 100%;
	width: 100%;
}
.index_search .el-carousel .el-carousel__container .el-carousel__item.is-active {
	z-index: 0;
}
.index_search .el-carousel__button{
	opacity: 1;
	width:20px;
	height:10px;
	border-radius: 5px;
}
.index_search .el-carousel .el-carousel__indicators {
	bottom: 80px;
}
.index_search .el-carousel .el-carousel__indicator.is-active button{
	opacity: 1;
	width:30px;
	background-color: #FF892A;
}
.index_select_group{
	width: 100%;
	height: 12%;
	display: flex;
}
.index_select .index_select_group .el-radio-button{
	flex: 1;
}
.index_select .index_select_group .el-radio-button .el-radio-button__inner {
	width: 100%;
	height: 100%;
	display: flex;
	border: 0px solid #dcdfe6;
	font-size:16px;
	font-family:思源黑体;
	font-weight:bold;
	color:rgba(170,170,170,1);
	background-color: transparent;
	background-image: url('../static/img/trapezoid1.png');
	background-size: cover;
	justify-content: center;
	align-items: center;
}
.index_select .index_select_group .el-radio-button .el-radio-button__inner img{
	margin-right: 10px;
}
.index_select .index_select_group .el-radio-button:first-child .el-radio-button__inner{
	border-radius:6px 6px 0px 0px;
}
.index_select .index_select_group .el-radio-button:last-child .el-radio-button__inner{
	border-radius: 0 6px 0 0;
}
.index_select .el-radio-button__orig-radio:checked+.el-radio-button__inner{
	color: #fff;
    background-image: url('../static/img/trapezoid.png');
	background-size: cover;
	background-color:  transparent;
    border-color: transparent;
    -webkit-box-shadow: -1px 0 0 0 transparent;
    box-shadow: -1px 0 0 0 transparent;
}
.index_select .el-radio-group {
    display: flex;
    line-height: 1;
    vertical-align: middle;
    font-size: 0;
}
.index_select_wrapper{
  height: 326px;
	background-color: transparent;
	box-shadow:0px 0px 20px 0px rgba(0, 0, 0, 0.35);
	border-radius:0px 0px 6px 6px;
	overflow: auto
}
.index_select_list{
	color: #999999;
	display: flex;
  	flex-wrap: wrap;
	margin-top: 7px;
	justify-content: flex-start;
}
.media_select_list{
	color: #999999;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}
.theme_select_list{
	color: #FF8752;
	display: flex;
  	flex-wrap: wrap;
	justify-content: flex-start;
}
.index_type_bottom{
	width: 989px;
	height: 573px;
	margin: 0 auto;
	position: relative;
	background: url('../static/img/type_back.png');
	background-size: 100% 100%;
}
.index_type_bottom span{
	font-size:20px;
	font-family:Adobe Heiti Std R;
	font-weight:normal;
	color:rgba(255,135,82,1);
}
.index_select_item{
	height: 20px;
	margin: 29px 29px 0px 29px;
	padding: 15px 5px;
	display: flex;
	font-size: 16px;
	justify-content: center;
	cursor: pointer;
}
.index_select_item img{
	width: 16px;
	height: 16px;
	margin-right: 5px;
}
.theme_item{
	width: 80px;
	height: 80px;
	background-image: url('../static/img/eightBorder.png');
	background-size: 100% 100%;
	margin: 32px;
	display: flex;
	font-size: 18px;
	font-family:思源黑体;
	font-weight:bold;
	justify-content: center;
	cursor: pointer;
}
.theme_item span{
	margin: auto 0px;
}
.index_select_muni{
	display: flex;
	align-items: center;
	margin: 30px auto 23px auto;
}
.index_select_county{
	display: flex;
	align-items: center;
	margin: 10px auto 23px auto;
}
.index_select_title{
	font-size:18px;
	font-family:思源黑体;
	font-weight:bold;
	color:rgba(255,135,82,1);
	line-height:16px;
	margin-left: 5px;
	letter-spacing:2px;
}
.index_select_toggle{
	width: 1100px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;
	margin: 10px 0px 0px 22px;
}
.index_select_media{
	width: 173px;
	height: 100px;
	margin-left: 40px;
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;
	background:rgba(255,255,255,1);
	background-image: url('../static/img/fourBorder.png');
	background-size: 100% 100%;
	font-family:思源黑体;
	color:rgba(153,153,153,1);
	line-height:22px;
	word-break: normal;
	cursor: pointer;
}
.index_select_media .select_media_title{
	margin: auto 13px;
  font-size: 18px;
}
.index_select_media .select_media_num{
	margin: 0px 10px 16px 10px;
  font-size: 14px;
}
.index_type_item1{
	width: 366px;
	height: 483px;
	position: absolute;
	top: 46px;
	left: 319px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	transition: all 0.6s;
}
.index_type_item1 img{
	height: 163px;
	width: 186px;
}

.index_type_item2{
	width: 207px;
	height: 260px;
	position: absolute;
	top: 288px;
  left: 131px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;
	transition: all 0.6s;
}
.index_type_item2 img{
	height: 162px;
	width: 105px;
}
.index_type_item3{
	width: 207px;
	height: 292px;
	position: absolute;
	top: 38px;
    left: 133px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor:	pointer;
	transition: all 0.6s;
}
.index_type_item3 img{
	height: 162px;
	width: 105px;
	display: block;
    opacity:100; 
	filter: alpha(opacity=100);
}
.index_type_item4{
	width: 207px;
	height: 300px;
	position: absolute;
	top: 36px;
  	left: 662px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;
	cursor: pointer;
	transition: all 0.6s;
}
.index_type_item4 img{
	height: 166px;
	width: 115px;
	display: block;
  	opacity:1; 
  	filter: alpha(opacity=100);
}
.index_type_item5{
	width: 207px;
	height: 258px;
	position: absolute;
	top: 288px;
	left: 661px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;
	cursor: pointer;
	transition: all 0.6s;
}
.index_type_item5 img{
	height: 147px;
	width: 104px;
	display: block;
  	opacity:1; 
  	filter: alpha(opacity=100);
}
.index_footer{
	width: 100%;
	height: 227px;
	background:rgba(62,78,112,1);
}
.index_footer_link{
	width: 100%;
	height: 40px;
	background:rgba(51,68,89,1);
}
.index_footer_copy{
	width: 100%;
	height: 187px;
}
.index_link_wrapper{
	width: 800px;
	height: 100%;
	margin: 0 auto;
	display: flex;
}
.index_link_item:hover{
	color:#ff8752
}
.index_link_item{
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size:14px;
	font-family:思源黑体;
	font-weight:bold;
	color:#6FBAFF;
	line-height:16px;
	cursor: pointer;
}
.index_copy_wrapper{
	display: flex;
	width: 600px;
	height: 100%;
	margin: 0 auto;
	font-size:14px;
	font-family:思源黑体;	
	font-weight:bold;
	color:#6FBAFF;
	line-height:16px;
}
.index_copy_item{
	flex: 1;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
.index_copy_item span {
	position: absolute;
	bottom: 0;
}
.index_link_line{
	flex: 0.01;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 24px;
	color:#6FBAFF
}
.type_img_wrapper{
	width: 207px;
	height: 198px;
	display: flex;
  justify-content: center;
}
.type_img_wrapper:hover{
	background: url('../static/img/img_hover.png');
	background-size: 100% 100%;
}
.index_type_item1 .type_img_wrapper{
	width: 366px;
	height: 349px;
}
.index_type_item1 .type_img_wrapper:hover{
	background: url('../static/img/img_hover_tv.png');
	background-size: 100% 100%;
}
.type_img_wrapper img{
	margin-top: 22px;
}
.index_type_item1 .type_img_wrapper img{
	margin-top: 170px;
}
.index_type_item5 .type_img_wrapper img{
	margin-top: 40px;
}
.type_img_wrapper:hover img{
    opacity:0.3;  
    filter: alpha(opacity=60);
}
.select-search-wrapper {
	display: flex;
	position: absolute;
	top: 200px;
	left: 980px;
	transform: translateX(-50%);
	z-index: 6;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue